export default "__VITE_ASSET__96477267__"